module.exports = "././img/qld-crest-on-left-2linesidestacked-b-w-01.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/qld-crest-on-left-2linesidestacked-b-w-01.svg
// module id = 824
// module chunks = 0